import axios from '@/utils/request';

const v1 = `v1/admin`;

export const getProducts = () => axios.get(`${v1}/products`);
export const getProductsByCompany = (data) => axios.post(`${v1}/productsByCompany`, data);
export const deleteProducts = (data) => axios.post(`${v1}/products/delete`, data);
export const createProduct = (data) => axios.post(`${v1}/product`, data);
export const importProducts = (data) => axios.post(`${v1}/products/import`, data);

export const getComProducts = ({ company_id = 1, size = 10, page = 1 }) => axios.get(`${v1}/products`, { params: { company_id, page, size } });
